import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
    tatCaApp: [],
    danhSachAppPaging: [],
    listApp: [],
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
